var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24C0.5 11.0425 11.0425 0.5 24 0.5C36.9575 0.5 47.5 11.0425 47.5 24C47.5 36.9575 36.9575 47.5 24 47.5C11.0425 47.5 0.5 36.9575 0.5 24ZM3.11809 24C3.11809 35.5148 12.4852 44.8819 24 44.8819C35.5148 44.8819 44.8819 35.5148 44.8819 24C44.8819 12.4852 35.5148 3.11809 24 3.11809C12.4852 3.11809 3.11809 12.4852 3.11809 24Z",
    fill: "#FF5A5F",
    stroke: "#FF5A5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.6768C23.0009 10.6768 22.191 11.4867 22.191 12.4858V28.8364C22.191 29.8355 23.0009 30.6455 24 30.6455C24.9991 30.6455 25.809 29.8355 25.809 28.8364V12.4858C25.809 11.4867 24.9991 10.6768 24 10.6768Z",
    fill: "#FF5A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33.6221C23.0009 33.6221 22.191 34.432 22.191 35.4311V35.5138C22.191 36.5129 23.0009 37.3229 24 37.3229C24.9991 37.3229 25.809 36.5129 25.809 35.5138V35.4311C25.809 34.432 24.9991 33.6221 24 33.6221Z",
    fill: "#FF5A5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c2b6fb13ddc747bcc50fb23d7cd16217.svg";
export { ForwardRef as ReactComponent };